export default "__VITE_ASSET__cdaaf706__"